import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import uploadToCloudinary from "../utils/upload"; // 🔥 Tera Cloudinary Function

function Profile() {
  const navigate = useNavigate();
  
  // --- States ---
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isEditing, setIsEditing] = useState(false); // Edit Mode Toggle
  const [saving, setSaving] = useState(false);

  // Form Data (Edit karte waqt ye change hoga)
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    address: "",
  });

  // Files for Upload
  const [newProfilePic, setNewProfilePic] = useState(null);
  const [newIdProof, setNewIdProof] = useState(null);

  // --- 1. Fetch Profile Data on Load ---
  useEffect(() => {
    const fetchProfile = async () => {
      const token = localStorage.getItem("token");
      if (!token) {
         navigate("/login");
         return;
      }

      try {
        const res = await fetch("https://borrowhub-backend.onrender.com/api/user/profile", {
          headers: { Authorization: `Bearer ${token}` }
        });
        const data = await res.json();
        
        if (data.user) {
          setUser(data.user);
          // LocalStorage bhi sync rakho
          localStorage.setItem("user", JSON.stringify(data.user));
          
          // Form data ko bhi initialize kar do
          setFormData({
            name: data.user.name || "",
            phone: data.user.phone || "",
            address: data.user.address || "",
          });
        }
      } catch (err) {
        console.error("Error fetching profile:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchProfile();
  }, [navigate]);

  // --- 2. Input Change Handler ---
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // --- 3. Save Changes (Upload + Update) ---
  const handleSave = async () => {
    if (!formData.address || formData.address.trim() === "") {
      return alert("⚠️ Address khali nahi chhod sakte bhai!");
    }
    setSaving(true);
    try {
      let profileUrl = user.profilePic;
      let idUrl = user.idProof;

      // A. Agar Nayi Profile Pic select ki hai to upload karo
      if (newProfilePic) {
        console.log("Uploading Profile Pic... 📸");
        profileUrl = await uploadToCloudinary(newProfilePic);
      }

      // B. Agar Naya ID Proof select kiya hai to upload karo
      if (newIdProof) {
        console.log("Uploading ID Proof... 🆔");
        idUrl = await uploadToCloudinary(newIdProof);
      }

      // C. Backend Update Call
      const token = localStorage.getItem("token");
      const res = await fetch("https://borrowhub-backend.onrender.com/api/user/update-profile", {
        method: "PUT",
        headers: { 
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}` 
        },
        body: JSON.stringify({
          name: formData.name,
          phone: formData.phone,
          address: formData.address,
          profilePic: profileUrl,
          idProof: idUrl
        }),
      });

      const data = await res.json();

      if (data.success) {
        alert("✅ Profile Updated Successfully!");
        setUser(data.user); // Update UI
        localStorage.setItem("user", JSON.stringify(data.user)); // Update Storage
        setIsEditing(false); // Edit mode band
        setNewProfilePic(null); // Clear temp files
        setNewIdProof(null);
      } else {
        alert("Update Failed: " + data.message);
      }

    } catch (err) {
      console.error(err);
      alert("Something went wrong!");
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div className="text-center mt-5"><div className="spinner-border text-primary"></div></div>;
  if (!user) return null;

  const isVerified = user.address && user.idProof;

  return (
    <div className="container mt-5 mb-5">
      <div className="row justify-content-center">
        <div className="col-md-8 col-lg-6">
          
          <div className="card shadow-lg border-0 rounded-4 overflow-hidden">
            
            {/* --- HEADER --- */}
            <div className={`card-header text-center py-4 ${isVerified ? "bg-success" : "bg-warning"} text-white`}>
              <h3 className="fw-bold m-0">
                {isVerified ? "Verified Member ✅" : "Unverified User ⚠️"}
              </h3>
              <small>{isVerified ? "Your Identity is Verified" : "Please complete your profile details"}</small>
            </div>

            <div className="card-body p-4">
              
              {/* --- 1. PROFILE PICTURE SECTION --- */}
              <div className="text-center position-relative mb-4">
                <div style={{ display: "inline-block", position: "relative" }}>
                  <img 
                    src={newProfilePic ? URL.createObjectURL(newProfilePic) : (user.profilePic || "https://cdn-icons-png.flaticon.com/512/149/149071.png")} 
                    alt="Profile" 
                    className="rounded-circle border border-4 border-white shadow"
                    style={{ width: "130px", height: "130px", objectFit: "cover", marginTop: "-70px", backgroundColor: "#fff" }}
                  />
                  
                  {/* Edit Mode Camera Icon */}
                  {isEditing && (
                    <label 
                      className="position-absolute bottom-0 end-0 bg-dark text-white rounded-circle p-2 shadow"
                      style={{ cursor: "pointer", transform: "translate(10%, 10%)" }}
                    >
                      📷
                      <input type="file" hidden accept="image/*" onChange={(e) => setNewProfilePic(e.target.files[0])} />
                    </label>
                  )}
                </div>
                
                {!isEditing && <h2 className="fw-bold mt-2">{user.name}</h2>}
                <p className="text-muted">{user.email}</p>
              </div>

              {/* --- 2. EDITABLE FORM --- */}
              <div className="px-2">
                
                {/* NAME */}
                <div className="mb-3">
                  <label className="fw-bold small text-muted">FULL NAME</label>
                  {isEditing ? (
                    <input type="text" className="form-control" name="name" value={formData.name} onChange={handleChange} />
                  ) : (
                    <p className="lead fw-semibold">{user.name}</p>
                  )}
                </div>

                {/* PHONE */}
                <div className="mb-3">
                  <label className="fw-bold small text-muted">PHONE NUMBER</label>
                  {isEditing ? (
                    <input type="text" className="form-control" name="phone" value={formData.phone} onChange={handleChange} />
                  ) : (
                    <p className="lead fw-semibold">{user.phone || "Not Provided"}</p>
                  )}
                </div>

                {/* ADDRESS */}
                <div className="mb-3">
                  <label className="fw-bold small text-muted">PERMANENT ADDRESS</label>
                  {isEditing ? (
                    <textarea className="form-control" rows="3" name="address" value={formData.address} onChange={handleChange}></textarea>
                  ) : (
                    <div className="p-3 bg-light rounded border">
                      {user.address || <span className="text-danger">Address missing. Please add it.</span>}
                    </div>
                  )}
                </div>

                {/* ID PROOF */}
                <div className="mb-4">
                  <label className="fw-bold small text-muted d-block mb-2">GOVT ID PROOF (Aadhaar/DL)</label>
                  
                  {/* View Mode ID */}
                  {!isEditing && (
                    user.idProof ? (
                      <img src={user.idProof} alt="ID" className="img-fluid rounded border shadow-sm w-100" style={{maxHeight: "200px", objectFit: "contain"}} />
                    ) : (
                      <div className="alert alert-danger py-2">❌ Not Uploaded Yet</div>
                    )
                  )}

                  {/* Edit Mode ID Upload */}
                  {isEditing && (
                    <div className="border p-3 rounded bg-light text-center">
                      {/* Preview if New File Selected */}
                      {newIdProof ? (
                         <div className="mb-2">
                            <p className="small text-success fw-bold">New File Selected:</p>
                            <img src={URL.createObjectURL(newIdProof)} alt="Preview" className="img-fluid rounded" style={{maxHeight: "150px"}} />
                         </div>
                      ) : (
                         user.idProof && <img src={user.idProof} alt="Old ID" className="img-fluid rounded mb-2 opacity-50" style={{maxHeight: "100px"}} />
                      )}
                      
                      <input type="file" className="form-control mt-2" accept="image/*" onChange={(e) => setNewIdProof(e.target.files[0])} />
                      <small className="text-muted">Upload new image to replace current ID.</small>
                    </div>
                  )}
                </div>

                {/* --- 3. ACTION BUTTONS --- */}
                <div className="d-grid gap-2">
                  {isEditing ? (
                    <>
                      <button className="btn btn-success fw-bold py-2" onClick={handleSave} disabled={saving}>
                        {saving ? "Saving & Uploading... ⏳" : "💾 SAVE CHANGES"}
                      </button>
                      <button className="btn btn-outline-secondary fw-bold" onClick={() => setIsEditing(false)} disabled={saving}>
                        ❌ CANCEL
                      </button>
                    </>
                  ) : (
                    <button className="btn btn-dark fw-bold py-2" onClick={() => setIsEditing(true)}>
                      ✏️ EDIT PROFILE
                    </button>
                  )}
                </div>

              </div>
            </div>
            
            {/* LOGOUT */}
            {!isEditing && (
                <div className="card-footer bg-light p-3 text-center">
                    <button className="btn btn-link text-danger text-decoration-none fw-bold" onClick={() => {
                        localStorage.clear();
                        navigate("/login");
                    }}>
                        Logout
                    </button>
                </div>
            )}

          </div>
        </div>
      </div>
    </div>
  );
}

export default Profile;